import React, { memo } from 'react';
import { AlertTriangle } from 'lucide-react';
import './BoardDragValidationModal.css';

function BoardDragValidationModal({
  isOpen,
  messages = [],
  confirmMode = false,
  onConfirm,
  onCancel,
}) {
  if (!isOpen || !messages.length) return null;

  return (
    <div
      className="board-drag-validation-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="board-drag-validation-title"
    >
      <div className="board-drag-validation-modal">
        <div className="board-drag-validation-icon" aria-hidden>
          <AlertTriangle size={28} strokeWidth={2} />
        </div>
        <h3 id="board-drag-validation-title" className="board-drag-validation-title">
          {confirmMode ? 'Atenção' : 'Operação não permitida'}
        </h3>
        <div className="board-drag-validation-messages">
          {messages.map((msg) => (
            <p key={msg} className="board-drag-validation-message">
              {msg}
            </p>
          ))}
        </div>
        {confirmMode ? (
          <div className="board-drag-validation-actions">
            <button
              type="button"
              className="board-drag-validation-btn board-drag-validation-btn--ghost"
              onClick={onCancel}
            >
              Cancelar
            </button>
            <button type="button" className="board-drag-validation-btn" onClick={onConfirm}>
              Confirmar
            </button>
          </div>
        ) : (
          <button type="button" className="board-drag-validation-btn" onClick={onConfirm}>
            Entendi
          </button>
        )}
      </div>
    </div>
  );
}

export default memo(BoardDragValidationModal);
